import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to desconnect the current application user.
 */
export class LogOutCommandBody implements CommandBody {}
